import React from 'react'
import { graphql } from 'gatsby'

import ArchivesPage from '../templates/archives'

export default function Index({ data: { allMdx } }) {
  return <ArchivesPage title="关键词列表" allMdx={allMdx} keyName="tags" />
}

export const pageQuery = graphql`
  query {
    allMdx(
      sort: {fields: [frontmatter___date], order: DESC}
      filter: {
        fields: {status: {eq: "online"}}
        fileAbsolutePath: {regex: "//blog//"}
      }
    ) {
      edges {
        node {
          excerpt(pruneLength: 190)
          id
          fields {
            title
            slug
            date
            datetime
            description
            categories
            tags
          }
          parent {
            ... on File {
              sourceInstanceName
            }
          }
          frontmatter {
            title
            date
            description
            banner {
              childImageSharp {
                sizes(maxWidth: 720) {
                  ...GatsbyImageSharpSizes
                }
              }
            }
            tags
            categories
          }
        }
      }
    }
  }
`
